import { render, staticRenderFns } from "./TicketDeCompra.vue?vue&type=template&id=5656ba18&scoped=true&"
import script from "./TicketDeCompra.vue?vue&type=script&lang=js&"
export * from "./TicketDeCompra.vue?vue&type=script&lang=js&"
import style0 from "./TicketDeCompra.vue?vue&type=style&index=0&id=5656ba18&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5656ba18",
  null
  
)

export default component.exports